import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Latex from "react-latex";
import he from "he";
import NotificationConfigurationTable from "./NotificationConfigurationTable";
import EndPoints from "../../../Api/EndPoints";

const NotificationConfigDashboard = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  dataClient,
  setPagePath,
  setNoTimeSet,
}) => {
  const [reportDashboardData, setReportDashboardData] = useState([]);
  const navigate = useNavigate();
  const accessToken = localStorage.getItem("other");
  const [headers, setHeaders] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (dataClient) {
      fetchDashboardData();
    }
  }, [dataClient]);

  const renderQuestionText = (questionText) => {
    const decodedQuestion = he.decode(questionText);
    const questionSegments = decodedQuestion.split(/(imgsrc=[^ ]+)/g);
    return questionSegments.map((segment, index) => {
      if (segment.startsWith("imgsrc=")) {
        const imageUrl = segment.replace("imgsrc=", "");
        return (
          <img
            key={index}
            src={imageUrl}
            alt={`Question Image ${index}`}
            style={{ width: "30px", height: "auto", margin: "5px" }}
          />
        );
      } else {
        return (
          <span key={index} className="truncated-text-2">
            <Latex>{segment}</Latex>
          </span>
        );
      }
    });
  };

  const ClientBranchID = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id;

  const fetchDashboardData = async () => {
    setIsLoading(true);
    setIsMessageBoxVisible(true);
    setMessageBox(
      <div className="Container-messageBOX">
        <div className="messagebox-insider1">
          <div className="loader-tc"></div>
          <span style={{ marginLeft: "10px", marginTop: "3px" }}>
            Loading data, please wait...
          </span>
        </div>
      </div>
    );
    setActiveImg(false);

    const slowLoadingTimer = setTimeout(() => {
      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <div className="loader-tc"></div>
            <span style={{ marginLeft: "10px", marginTop: "3px" }}>
              This is taking longer than usual, please wait a moment...
            </span>
          </div>
        </div>
      );
    }, 5000);

    try {
      const response = await fetch(
        `${EndPoints.NotificationConfigurationDashboard}?client_branch_id=${ClientBranchID}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(
          "Failed to fetch dashboard data. Please check the API or authentication details."
        );
      }

      const result = await response.json();
      const tableData = result?.data || [];
      const rawHeaders = tableData[0] || [];
      const rows = tableData.slice(1) || [];

      const formattedHeaders = rawHeaders.map((header) =>
        String(header)
          .replace(/^t\*/, "")
          .replace(/^d\*/, "")
          .replace(/^s\*/, "")
          .replace(/^n\*/, "")
      );

      const transformedRows = rows.map((row) =>
        row.map((cell) => {
          if (cell === "" || cell === null || cell === undefined) {
            return "---";
          }
          return cell;
        })
      );

      setHeaders(formattedHeaders);
      setReportDashboardData(transformedRows);

      // ✅ Success — clear timer and hide loader
      clearTimeout(slowLoadingTimer);
      setIsLoading(false);
      setIsMessageBoxVisible(false);

    } catch (error) {
      // ✅ Error — clear timer and show error message
      clearTimeout(slowLoadingTimer);
      setIsLoading(false);
      setIsMessageBoxVisible(true);

      setMessageBox(
        <div className="Container-messageBOX">
          <div className="messagebox-insider1">
            <span style={{ marginLeft: "10px", marginTop: "3px" }}>
              Error: {error.message}
            </span>
          </div>
        </div>
      );

      console.error("Error fetching dashboard data:", error);
    }
  };

  return (
    <div
      style={{
        height: "auto",
        width: "100%",
        paddingLeft: "37px",
        marginBottom: "40px",
      }}
    >
      <div className="">
        <div
          style={{
            backgroundColor: "white",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            zIndex: 1001,
            top: 0,
          }}
        >
          <p style={{ color: "#2F2E40", fontSize: "30px" }}>
            Notification Configuration Dashboard
          </p>
          <div style={{ display: "flex" }}>
          </div>
        </div>

        <p style={{ marginTop: "10px", color: "#2F2E40" }}>
          View notifications configured for the screens listed below, click on the screen to view and modify the communication mode and messages.
        </p>

        <div>
          <NotificationConfigurationTable
            headers={headers}
            data={reportDashboardData}
            searchPlaceholder="Filter Screen..."
            dataClient={dataClient}
            setPagePath={setPagePath}
            renderQuestionText={renderQuestionText}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            bulk={false}
          />
        </div>
      </div>
    </div>
  );
};

export default NotificationConfigDashboard;








  // const fetchDashboardData = async () => {
  //   try {
  //     const response = await fetch(
  //       `${EndPoints.NotificationConfigurationDashboard}?client_branch_id=${ClientBranchID}`,
  //       {
  //         method: "GET",
  //         headers: {
  //           Authorization: `Bearer ${accessToken}`,
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     if (!response.ok) {
  //       throw new Error(
  //         "Failed to fetch dashboard data. Please check the API or authentication details."
  //       );
  //     }

  //     const result = await response.json();
  //     const tableData = result?.data || [];
  //     const rawHeaders = tableData[0] || [];
  //     const rows = tableData.slice(1) || [];

  //     // const formattedHeaders = rawHeaders.map((header) => String(header));
  //     const formattedHeaders = rawHeaders.map((header) =>
  //       String(header)
  //         .replace(/^t\*/, "")
  //         .replace(/^d\*/, "")
  //         .replace(/^s\*/, "")
  //         .replace(/^n\*/, "")
  //     );

  //     const transformedRows = rows.map((row) =>
  //       row.map((cell) => {
  //         if (cell === "" || cell === null || cell === undefined) {
  //           return "---";
  //         }
  //         return cell;
  //       })
  //     );

  //     setHeaders(formattedHeaders);
  //     setReportDashboardData(transformedRows);
  //   } catch (error) {
  //     console.error("Error fetching dashboard data:", error);
  //   }
  // };

  // const handleCancel = () => {
  //   window.location.reload();
  // };



{/* <button
              className="create-test-section-btn"
              style={{
                marginRight: "18px",
                boxShadow: "0px 4px 4px 0px #00000040",
              }}
              onClick={handleCancel}
            >
              CANCEL
            </button> */}
            {/* <button
              className="create-test-section-btn"
              onClick={() => {
                navigate(`/updated_user_group`);
              }}
            >
              NEW
              <span style={{fontSize: "14px", fontWeight: "bold"}}>+</span>
            </button> */}